import type { AppEnvironment } from "../lib/env";
import type { CitywideUserProfile, PolicyNote, ProductEntitlement } from "../lib/types";

export type CreatePolicyNoteInput = {
  title: string;
  body: string;
  category?: string;
  sourceType?: string;
};

export interface PolicyRepository {
  getUserProfile(userId: string): Promise<CitywideUserProfile | null>;
  upsertUserProfile(input: Pick<CitywideUserProfile, "user_id"> & Partial<CitywideUserProfile>): Promise<CitywideUserProfile>;
  getEntitlement(userId: string, environment: AppEnvironment): Promise<ProductEntitlement | null>;
  listPolicyNotes(userId: string): Promise<PolicyNote[]>;
  createPolicyNote(userId: string, input: CreatePolicyNoteInput): Promise<PolicyNote>;
}

export class RepositoryError extends Error {
  constructor(message: string, public readonly cause?: unknown) {
    super(message);
    this.name = "RepositoryError";
  }
}
